import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

function TrustScoreGauge({ score, comparison, lastUpdated }) {
  // Color based on score
  const getColor = (value) => {
    if (value >= 80) return '#10b981'; // green
    if (value >= 60) return '#f59e0b'; // yellow
    if (value >= 40) return '#f97316'; // orange
    return '#ef4444'; // red
  };

  const color = getColor(score);
  
  // Data for gauge (showing score out of 100)
  const data = [
    { value: score },
    { value: 100 - score }
  ];

  return (
    <div className="flex flex-col md:flex-row items-center justify-between">
      {/* Gauge */}
      <div className="flex-1 flex items-center justify-center" data-testid="trust-score-gauge">
        <div className="relative" style={{ width: 300, height: 200 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="80%"
                startAngle={180}
                endAngle={0}
                innerRadius={80}
                outerRadius={120}
                paddingAngle={0}
                dataKey="value"
              >
                <Cell fill={color} />
                <Cell fill="#e5e7eb" />
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          
          {/* Score Text */}
          <div className="absolute inset-0 flex flex-col items-center justify-end pb-8">
            <div className="text-5xl font-bold" style={{ color }} data-testid="trust-score-value">
              {score.toFixed(1)}
            </div>
            <div className="text-sm text-gray-600 mt-1">Trust Score</div>
          </div>
        </div>
      </div>

      {/* Details */}
      <div className="flex-1 space-y-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Overall Trust Score</h2>
          <p className="text-gray-600">Aggregated measurement across all three pillars</p>
        </div>

        {comparison && (
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="text-sm text-gray-600 mb-1">Compared to previous period</div>
            <div className="flex items-center gap-2">
              {comparison.trust_score_delta >= 0 ? (
                <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                </svg>
              ) : (
                <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                </svg>
              )}
              <span className={`text-2xl font-bold ${
                comparison.trust_score_delta >= 0 ? 'text-green-600' : 'text-red-600'
              }`} data-testid="trust-score-delta">
                {comparison.trust_score_delta > 0 ? '+' : ''}{comparison.trust_score_delta.toFixed(1)}
              </span>
              <span className="text-gray-600">points</span>
            </div>
          </div>
        )}

        {lastUpdated && (
          <div className="text-sm text-gray-500">
            Last updated: {new Date(lastUpdated).toLocaleString()}
          </div>
        )}
      </div>
    </div>
  );
}

export default TrustScoreGauge;
